module.exports = __webpack_public_path__ + "img/badge-key.27d52ea5.png";